import React from 'react';
import { Loader } from 'panamera-react-ui';
var css = {
  "mainWrapper": "oalp-1A_Tp",
  "loaderMain": "oalp-1kRFl"
};
export var CXELoadingWidget = function CXELoadingWidget() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: css.mainWrapper
  }, /*#__PURE__*/React.createElement(Loader, {
    containerSize: "16px",
    stroke: "3px",
    className: css.loaderMain
  })));
};
export default CXELoadingWidget;